import {
  isProvenanceForbidden,
  useProcessProvenance,
} from "@via/api/git-provenance.api.tsx";
import GitProvenancePanel from "@via/components/git-provenance/git-provenance-panel.tsx";
import { JSX } from "react";

/**
 * Whether the editor offers the tab: a saved process (there is nothing to read before the first
 * save) that the viewer can edit, because the read needs write permission, the same rule as the
 * git panel in Files.
 */
export const isProvenanceTabAvailable = (
  processId: number | undefined,
  canEditProcess: boolean
): boolean => undefined !== processId && processId > 0 && canEditProcess;

/**
 * The process editor's Provenance tab (git-4-2). The editor only offers it to someone who can
 * edit the process, the same audience the server allows, so a 403 here is a race, not the norm.
 */
export default function ProvenanceTab({
  processId,
}: {
  processId: number | undefined;
}): JSX.Element {
  const { data, isLoading, isError, error } = useProcessProvenance(processId);
  return (
    <GitProvenancePanel
      subject="process"
      data={data}
      isLoading={isLoading}
      isError={isError}
      isForbidden={isProvenanceForbidden(error)}
    />
  );
}
